import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Organicé toda la programación del box en una tarde. Ahora tengo cada WOD pensado y escalado para todos mis grupos. Nunca más el domingo de pánico antes de la semana.',
  name: 'Lucas M.',
  location: 'Buenos Aires',
  role: 'Instructor de Crossfit en Box Propio'
}, {
  quote: 'Los protocolos de escalado por nivel cambiaron todo. Mis alumnos avanzaron más en 2 meses que en todo el año anterior. Y dejaron de abandonar.',
  name: 'Martín R.',
  location: 'Rosario',
  role: 'Instructor en Box Comercial'
}, {
  quote: 'Adapto el mismo WOD a 3 niveles distintos en 5 minutos. Antes me llevaba horas pensar qué hacer con un grupo heterogéneo. Ahora abro el PDF y está todo.',
  name: 'Agustina F.',
  location: 'Córdoba',
  role: 'Instructora de Crossfit Grupal e Individual'
}];
export function ShortTestimonials() {
  return <section className="py-10 md:py-16 px-4 bg-cf-dark" data-id="element-331">
      <div className="max-w-6xl mx-auto grid md:grid-cols-3 gap-4 md:gap-6" data-id="element-332">
        {testimonials.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.1
      }} className="bg-cf-card p-4 md:p-6 rounded-lg border border-white/5 flex flex-col justify-between" data-id="element-333">
            <div data-id="element-334">
              <div className="flex gap-1 text-cf-gold mb-3 md:mb-4" data-id="element-335">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 md:w-4 md:h-4 fill-current" data-id="element-336" />)}
              </div>
              <p className="text-sm md:text-base text-gray-300 italic mb-4 md:mb-6" data-id="element-337">
                "{t.quote}"
              </p>
            </div>
            <div data-id="element-338">
              <p className="font-bold text-white text-sm md:text-base" data-id="element-339">
                {t.name} — {t.location}
              </p>
              <p className="text-xs md:text-sm text-cf-gold" data-id="element-340">{t.role}</p>
            </div>
          </motion.div>)}
      </div>
    </section>;
}